export default __webpack_public_path__ + "static/media/Ethereum2.bc76a56f.png";